//
// Preload JS
// --------------------------------------------------
// Removes preload class to enable transitions - removes style attribute from body to reduce FUOC

window.addEventListener('load', event => {
    document.body.removeAttribute('style');
    document.body.classList.remove('preload');
});